import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CompanyActions } from './company.actions';
import { SegmentParentOperation } from '../models/segment-parent.model';
import { CompanyDetailPayload } from '../models/company.model';
import { SupplierSettingsForm } from '../models/company-form.model';
import {
  BuyerConfigSettingsSavePayload,
  BuyerCountrySettingsSavePayload,
} from '../models/company-buyer-config.model';

@Injectable({ providedIn: 'root' })
export class CompanyActionsFacade {
  private readonly _store = inject(Store);

  public loadCompanies(limit?: number): void {
    this._store.dispatch(CompanyActions.loadCompanies({ limit }));
  }

  public search(query: string): void {
    this._store.dispatch(CompanyActions.setSearch({ search: query }));
  }

  public goToPage(page: number): void {
    this._store.dispatch(CompanyActions.setPage({ page }));
  }

  public resetState(): void {
    this._store.dispatch(CompanyActions.resetState());
  }

  public startCreate(): void {
    this._store.dispatch(CompanyActions.startCreate());
  }

  public selectCompany(id: number): void {
    this._store.dispatch(CompanyActions.selectCompany({ id }));
  }

  public clearForm(): void {
    this._store.dispatch(CompanyActions.clearForm());
  }

  public loadCurrencies(): void {
    this._store.dispatch(CompanyActions.loadCurrencies());
  }
  public loadSupplierSettings(id: number): void {
    this._store.dispatch(CompanyActions.loadSupplierSettings({ id }));
  }

  public saveCompany(payload: CompanyDetailPayload): void {
    this._store.dispatch(CompanyActions.saveCompany({ payload }));
  }

  public updateCompany(id: number, payload: CompanyDetailPayload): void {
    this._store.dispatch(CompanyActions.updateCompany({ id, payload }));
  }

  public deleteCompany(id: number): void {
    this._store.dispatch(CompanyActions.deleteCompany({ id }));
  }

  public saveSupplierSettings(
    id: number,
    settings: SupplierSettingsForm,
  ): void {
    this._store.dispatch(CompanyActions.saveSupplierSettings({ id, settings }));
  }

  public enableSegmentation(id: number): void {
    this._store.dispatch(CompanyActions.enableSegmentation({ id }));
  }

  public disableSegmentation(id: number): void {
    this._store.dispatch(CompanyActions.disableSegmentation({ id }));
  }

  public loadSegmentParents(id: number): void {
    this._store.dispatch(CompanyActions.loadSegmentParents({ id }));
  }
  public fetchNetsuiteCompany(_internalId: number, _userType: string): void {
    //TODO implement in proper ticket
    return;
  }
  public saveSegmentParents(
    id: number,
    operations: SegmentParentOperation[],
  ): void {
    this._store.dispatch(CompanyActions.saveSegmentParents({ id, operations }));
  }

  public loadBuyerConfigSettings(id: number): void {
    this._store.dispatch(CompanyActions.loadBuyerConfigSettings({ id }));
  }

  public saveBuyerConfigSettings(
    payload: BuyerConfigSettingsSavePayload,
  ): void {
    this._store.dispatch(CompanyActions.saveBuyerConfigSettings({ payload }));
  }

  public saveBuyerCountrySettings(
    payload: BuyerCountrySettingsSavePayload,
  ): void {
    this._store.dispatch(CompanyActions.saveBuyerCountrySettings({ payload }));
  }

  public resetBuyerConfigSettings(id: number): void {
    this._store.dispatch(CompanyActions.resetBuyerConfigSettings({ id }));
  }

  public registerWebhook(buyerId: number, webhook: string): void {
    this._store.dispatch(CompanyActions.registerWebhook({ buyerId, webhook }));
  }

  public unsubscribeWebhook(buyerId: number): void {
    this._store.dispatch(CompanyActions.unsubscribeWebhook({ buyerId }));
  }
}
